export const GET_ARTIST_WITH_TRACKS = `
    query tracksByArtistId($artistId: ID!) {
        artist(id: $artistId) {
            id
            artist_name
            image
            bio
            created_at
            tracks {
                id
                title
                url
                track_type
                genre
                bpm
                duration
                song_key
                mood_1
                mood_2
                mood_3
                mood_4
                image
                artist {
                    id
                    artist_name
                }
            }
        }
    }
`;

export const GET_TRACK_WITH_THREADS = `
    query getTrack($trackId: ID!) {
        track(id: $trackId) {
            id
            title
            release_package
            url
            genre
            mood_1
            mood_2
            mood_3
            mood_4
            bpm
            duration
            track_type
            image
            artist {
                id
                image
                artist_name
                artist_fb_url
                artist_ig_url
            }
            featured_artist {
                id
                artist_name
                image
                artist_fb_url
                artist_ig_url
            }
            mood_1
            mood_2
            mood_3
            mood_4
            tags
            song_description
            instrument_details_credits
            instruments
            track_conversations {
                id
                message_body
                posted_date
                user {
                    id
                    user_name
                    image
                }
                track_message_threads {
                    id
                    message_body
                    posted_date
                    user {
                        user_name
                        image
                        blurb
                    }
                }
            }
            stems {
                id
                title
                url
                track_type
                image
                artist {
                    id
                    artist_name
                    image
                }
            }
        }
    }
`;

export const GET_USER_WITH_THREADS = `
    query userWithThreads($userId: ID!) {
        user(id: $userId) {
            id
            user_name
            image
            track_conversations {
                id
                user {
                    id
                    user_name
                    image
                }
                message_body
                posted_date
            }
        }
    }
`;
 
export const GET_TRACKS_BY_ARTIST_ID = `
    query tracksByArtistId($artistId: ID!) {
        artist(id: $artistId) {
            id
            artist_name
            image
            bio
            created_at
            tracks {
                id
                title
                url
                genre
                bpm
                song_key
                mood_1
                mood_2
                mood_3
                mood_4
                image
            }
        }
    }
`;

export const GET_ALL_ARTISTS = `
    query {
        artists {
            id
            artist_name
            bio
            image
            tracks {
                id
                title
                url
                genre
                image
            }
            created_at
        }
    }
`;

export const GET_ALL_TRACKS = `
    query {
        tracks {
            id
            release_package
            title
            url
            track_type
            lyrics
            lyrics_type
            genre
            sub_genre
            song_key
            bpm
            duration
            mood_1
            mood_2
            mood_3
            mood_4
            tags
            song_description
            producer
            engineer
            instrument_details_credits
            instruments
            image
            created_at
            artist {
                id
                artist_name
                image
            }
            featured_artist {
                id
                artist_name
                image
            }
        }
    }
`;

export const GET_TRACKS_BY_IDS = `
    query getTracksByIds($trackIds: [ID!]!) {
        tracksByIds(trackIds: $trackIds) {
            id
            title
            release_package
            url
            track_type
            genre
            bpm
            duration
            song_key
            mood_1
            mood_2
            mood_3
            mood_4
            image
            artist {
                id
                artist_name
                image
            }
            featured_artist {
                id
                artist_name
                image
            }
        }
    }
`;


export const CREATE_NEW_USER = `
  mutation CreateUser(
    $first_name: String!, 
    $last_name: String!, 
    $email: String!
    $password: String!
) {
    createUser(
        first_name: $first_name, 
        last_name: $last_name, 
        email: $email,
        password: $password
    ) {
      id
      first_name
      last_name
      email
      created_at
    }
  }
`;

export const CHECK_USER_EXISTENCE = `
  query CheckUser($email: String!) {
    userByEmail(email: $email) {
      id
      email
    }
  }
`;

export const LOGIN_USER = `
  mutation LoginUser($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      success
      message
      user {
        id
        first_name
        last_name
        email
        created_at
      }
    }
  }
`;

export const GET_VOCAL_MENU_TRACKS = `
    query {
        vocal_tracks {
            id
            artist_name
            genres
            track_type
            title
            url
            image
        }
    }
`;